import { render, staticRenderFns } from "./DocumentComponent.vue?vue&type=template&id=6ec1413c&"
import script from "./DocumentComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports